import * as React from "react";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { useParams } from "react-router-dom";
import Paper from "@mui/material/Paper";
import { styled } from "@mui/material/styles";
import ThumbUpIcon from "@mui/icons-material/ThumbUp";
import ThumbDownAltIcon from "@mui/icons-material/ThumbDownAlt";
import Chip from "@mui/material/Chip";
import { Box } from "@mui/material";
import { getSubtitlesInfoApi, getSubtitlesApi } from "../services/subtitlesApi";
import {
  customToastify,
  checkErrorMessage,
  checkResponseData,
} from "../components/pages/utils/utilsFunctions";
import StarIcon from "@mui/icons-material/Star";
import StarHalfIcon from "@mui/icons-material/StarHalf";
const SERVER_URL = `${process.env.REACT_APP_SITEURL}/`;

const DemoPaper = styled(Paper)(({ theme }) => ({
  //   width: "90vh",
  //   height: "95%",
  padding: theme.spacing(2),
  ...theme.typography.body2,
  textAlign: "center",
}));

export default function ImgMediaCard(props) {
  const { userTypes, handleShowLoginForm } = props;
  const [subInfo, setSubinfo] = React.useState({
    coverUrl: null,
    fileName: null,
    nameOfMovie: null,
    subtitlesLanguage: null,
    subtitlesUploadId: null,
    type: null,
    season: null,
    episode: null,
  });
  const [subError, setSubError] = React.useState(false);
  const { id } = useParams();

  const getSubInfo = async (id) => {
    try {
      setSubinfo(null);
      let response = await getSubtitlesInfoApi({ subtitlesUploadId: id });
      const resData = checkResponseData(response);
      setSubError(false);

      if (resData["success"]) {
        // setSearchClick(false)
        setSubinfo(resData["data"]["data"][0]);

        // toast.update(toastMsg, { render: resData["message"] || "درخواست انجام شد", type: "success", isLoading: false, autoClose: 3000 });
      } else {
        // toast.update(toastMsg, { render: resData["message"] || "اتفاق غیر منتظره پیش آمده است", type: "info", isLoading: false, autoClose: 3000 });
      }
    } catch (error) {
      const errData = checkErrorMessage(error);
      let errMsg = errData["titles"] || errData["message"];

      customToastify("error", errMsg);
      setSubinfo({
        coverUrl: null,
        fileName: null,
        nameOfMovie: "ErrorUmlang",
        subtitlesLanguage: null,
        subtitlesUploadId: null,
        type: null,
        season: null,
        episode: null,
      });
      setSubError(true);
    }
  };

  const downloadFile = async (movieName, subtitlesUploadId) => {
    if (userTypes.length > 0) {
      let response = await getSubtitlesApi({ subtitlesUploadId });
      const href = URL.createObjectURL(response.data);

      // create "a" HTML element with href to file & click
      const link = document.createElement("a");
      link.href = href;
      link.setAttribute("download", `${movieName}-umlang.com.srt`); //or any other extension
      document.body.appendChild(link);
      link.click();

      // clean up "a" element & remove ObjectURL
      document.body.removeChild(link);
      URL.revokeObjectURL(href);
    } else handleShowLoginForm(true);
  };
  React.useEffect(() => {
    getSubInfo(id);
  }, [userTypes]);
  return (
    // <DemoPaper square={false}>{id}
    //     </DemoPaper>
    <Card sx={{ maxWidth: 300, mt: 1 }}>
      {subInfo ? (
        subError ? (
          <>
            <Typography>زیرنویسی با ای دی {id} پیدا نشد</Typography>
          </>
        ) : (
          <>
            <img
              style={{
                backgroundSize: "contain",
                height: "100%",
                width: "100%",
              }}
              src={`${subInfo.coverUrl}`}
            />
            <CardContent>
              <Typography gutterBottom component="div">
                نام فیلم : {subInfo.nameOfMovie}
              </Typography>
              <Typography gutterBottom component="div">
                زبان زیرنویس : {subInfo.subtitlesLanguage}
              </Typography>
              {subInfo.season ? (
                <Typography variant="body2" color="text.secondary">
                  فصل : {subInfo.season}
                </Typography>
              ) : null}
              {subInfo.episode ? (
                <Typography variant="body2" color="text.secondary">
                  قسمت : {subInfo.episode}
                </Typography>
              ) : null}
              <Box sx={{ textAlign: "center" }}>
                {subInfo.type == "umlang" ? (
                  <StarIcon color="secondary" />
                ) : null}
                {subInfo.type == "managerUpload" ? (
                  <StarHalfIcon color="secondary" />
                ) : null}
                <Typography component="div">
                  کدزیرنویس: {subInfo.subtitlesUploadId}
                </Typography>
                <br />
                <Button
                  onClick={() => {
                    navigator.clipboard.writeText(subInfo.subtitlesUploadId);
                    customToastify(
                      "info",
                      `آی دی : ${subInfo.subtitlesUploadId} کپی شد`
                    );
                  }}
                  variant="contained"
                  sx={{ m: 0.5 }}
                  size="small"
                >
                  کپی کد
                </Button>
                <Button
                  variant="contained"
                  onClick={() => {
                    navigator.clipboard.writeText(
                      `${SERVER_URL}/sub/${subInfo.subtitlesUploadId}`
                    );
                    customToastify(
                      "info",
                      `آی دی : ${SERVER_URL}/sub/${subInfo.subtitlesUploadId} کپی شد`
                    );
                  }}
                  sx={{ m: 0.5 }}
                  size="small"
                >
                  کپی آدرس
                </Button>
                <br />
                <Button
                  variant="contained"
                  onClick={() => {
                    downloadFile(
                      subInfo.nameOfMovie,
                      subInfo.subtitlesUploadId
                    );
                  }}
                  sx={{ m: 0.5 }}
                  size="small"
                >
                  دانلود
                </Button>
              </Box>
            </CardContent>
            <CardActions sx={{ textAlign: "center", display: "flow" }}>
              <Chip icon={<ThumbUpIcon />} label={100} variant="outlined" />
              <Chip icon={<ThumbDownAltIcon />} label={50} variant="outlined" />
            </CardActions>
          </>
        )
      ) : (
        <>
          <Typography>در حال دریافت اطلاعات ...</Typography>
        </>
      )}
    </Card>
  );
}
